<template>
  <div class="bg-white dark:bg-gray-800 rounded-xl shadow dark:shadow-lg p-6">
    <div class="flex flex-col md:flex-row md:items-center gap-6">
      <img src="https://randomuser.me/api/portraits/men/5.jpg" class="w-24 h-24 rounded-xl border-4 border-violet-400" />
      <div>
        <h2 class="text-2xl font-bold dark:text-white">John Doe</h2>
        <div class="text-gray-500 dark:text-gray-300 flex items-center gap-2 mt-1">
          <span>UX Designer</span>
          <span>•</span>
          <span>Vatican City</span>
        </div>
        <div class="text-gray-400 dark:text-gray-400 text-sm mt-1">Joined April 2021</div>
      </div>
      <div class="ml-auto">
        <button class="bg-violet-500 text-white px-4 py-2 rounded">Connected</button>
      </div>
    </div>
    <div class="mt-8 flex gap-4 border-b pb-2 dark:border-gray-700">
      <button class="px-4 py-2 font-semibold text-violet-600 dark:text-violet-400 border-b-2 border-violet-600 dark:border-violet-400">Profile</button>
      <button class="px-4 py-2 text-gray-500 dark:text-gray-300">Team</button>
      <button class="px-4 py-2 text-gray-500 dark:text-gray-300">Projects</button>
      <button class="px-4 py-2 text-gray-500 dark:text-gray-300">Connections</button>
    </div>
    <div class="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <h3 class="font-bold mb-2 dark:text-white">About</h3>
        <ul class="text-sm text-gray-600 dark:text-gray-300 space-y-1">
          <li><span class="font-semibold">Full Name:</span> John Doe</li>
          <li><span class="font-semibold">Status:</span> active</li>
          <li><span class="font-semibold">Role:</span> Developer</li>
          <li><span class="font-semibold">Country:</span> USA</li>
          <li><span class="font-semibold">Language:</span> English</li>
        </ul>
      </div>
      <div>
        <h3 class="font-bold mb-2 dark:text-white">Activity Timeline</h3>
        <ul class="text-sm text-gray-600 dark:text-gray-300 space-y-2">
          <li class="flex items-center gap-2">
            <span class="w-2 h-2 bg-violet-500 rounded-full"></span>
            12 Invoices have been paid <span class="bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded text-xs ml-2">invoice.pdf</span>
            <span class="ml-auto text-gray-400 text-xs">12 min ago</span>
          </li>
          <li class="flex items-center gap-2">
            <span class="w-2 h-2 bg-green-500 rounded-full"></span>
            Client Meeting <span class="ml-auto text-gray-400 text-xs">45 min ago</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template> 